import cn from 'clsx';
import { ButtonHTMLAttributes, forwardRef, Ref } from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: IconLookup;
  iconClassName?: string;
  title?: string;
}

function DesktopNavIconButton(
  { onClick, icon, iconClassName, title, className, 'aria-label': ariaLabel, ...props }: Props,
  ref: Ref<HTMLButtonElement>
) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'block cursor-pointer',
        'text-2xl',
        'bg-white hover:bg-slate-100 active:bg-slate-200',
        'text-slate-800 hover:text-slate-900 active:text-slate-950',
        'h-12 px-3 flex items-center justify-center rounded-md',
        className
      )}
      ref={ref}
      aria-label={ariaLabel ?? title}
      {...props}
    >
      <FontAwesomeIcon icon={icon} className={iconClassName} />
      {title && <span className="text-sm ml-2 font-semibold block xl:hidden 2xl:block whitespace-nowrap">{title}</span>}
    </button>
  );
}

export default forwardRef(DesktopNavIconButton);
